import { FormBase, FormJoin } from '@shared/interfaces/form';

export const sendEmail = async (form: FormJoin | FormBase) => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    return response.ok;
  } catch (error) {
    return error;
  }
};
